import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.athleteSports;
export const athleteSportsSelector = (state: RootState) => getState(state).data;
export const athleteSportsIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const athleteSportsIsReadySelector = (state: RootState) => getState(state).isReady;
export const athleteSportsErrorSelector = (state: RootState) => getState(state).error;
